import React from 'react';
import { Heading, Address, ContactDetails, SocialMedia } from '../../../common/CMS/elements';

export const ContactDetailsComponent = (props) => {

    const { sectionHeading, address, contactDetails, socialMedia, options } = props.content;

    const style = {
        backgroundImage: `url(${options.backgroundImage})`,
        backgroundColor: `${options.backgroundColour}`
    }
    const mainHeadingColor = {
        color: `${options.fontColors.mainHeadingFontColor}`
    }
    const headingColor = {
        color: `${options.fontColors.HeadingFontColor}`
    }
    const textColor = {
        color: `${options.fontColors.contentFontColors}`
    }
    return (
        contactDetails && <section className="col-12 kiwi-contact-details">
            <div className="kiwi-contact-details__background" style={style}>
                <div className="container">
                    {sectionHeading && <Heading size={"h2"} content={sectionHeading} style={mainHeadingColor} />}
                    <div className="contact-details row">
                        {address && <Address address={address} headingColor={headingColor} textColor={textColor} />}
                        {contactDetails && <ContactDetails contactDetails={contactDetails} headingColor={headingColor} textColor={textColor} />}
                        {socialMedia && <SocialMedia subHeading={socialMedia.subHeading} details={socialMedia.details} headingColor={headingColor} textColor={textColor} />}
                    </div>
                </div>
            </div>
        </section>
    )
};



// WEBPACK FOOTER //
// src/client/components/common/CMS/components/ContactDetailsComponent.js